.ConfidenceBridge {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 100%;
    text-align: center;
    transition: opacity 0.2s ease;

    &.isSkipped {
        opacity: 0.35;
    }
}

/* Round marker under the badge, holding the action icon */
.ConfidenceBridge__marker {
    display: grid;
    place-items: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    background: var(--soniq-t--global--background--color--primary--default);
    color: var(--soniq-t--global--text--color--label--default);

    & svg {
        flex-shrink: 0;
    }
}

/* On narrow screens the row stacks, so the badge and marker sit
   side by side and the link arrow points down at the resolution. */
@media (max-width: 760px) {
    .ConfidenceBridge {
        flex-direction: row;
        justify-content: flex-start;
        height: auto;
    }

    .ConfidenceBridge.isLink .ConfidenceBridge__marker svg {
        transform: rotate(90deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .ConfidenceBridge {
        transition: none;
    }
}
